import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import { IServiceType } from 'src/types/service-types';
import styles from '../assets/serviceType-actions.module.scss';
import DeleteServiceTypeAction from './DeleteServiceTypeAction';

const ServiceTypeActionsColumn: React.FunctionComponent<CellProps<IServiceType>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IServiceType>) => (
    <div className={classNames(styles.actions)}>
        <Link to={Router.generate(routes.SERVICE_TYPE_EDIT, { id: original.id })} className="btn btn-info">
            <FontAwesomeIcon icon={faPencilAlt} />
        </Link>
        <DeleteServiceTypeAction data={original} />
    </div>
);

export default ServiceTypeActionsColumn;
